// extracted by mini-css-extract-plugin
export var container = "_8e-0";
export var icon = "_8e-1";
export var text = "_8e-2";